import GlobalHeader from '../../../[locale]/(partners)/essence/components/EssenceHeader';
import PageLayout, { type PageLayoutProps } from './PageLayout';

export default PageLayout;
export type { PageLayoutProps };
export { GlobalHeader };
